import React, { useEffect, useState } from 'react';
import Icon from './icons/Icon';

/**
 * DensityToggle
 * 
 * Toggle between comfortable, compact, and spacious density modes.
 * Persists preference in localStorage.
 * Applies CSS custom property to root for global density control.
 */
export default function DensityToggle() {
  const [density, setDensity] = useState(() => {
    const stored = localStorage.getItem('admin-density');
    return stored || 'comfortable';
  });

  useEffect(() => {
    // Apply density to document root
    document.documentElement.setAttribute('data-density', density);
    localStorage.setItem('admin-density', density);
    
    // Set CSS custom property for density multiplier
    const multipliers = {
      compact: 0.75,    // 25% reduction
      comfortable: 1.0, // Default
      spacious: 1.25,   // 25% increase
    };
    
    const multiplier = multipliers[density] || 1.0;
    document.documentElement.style.setProperty('--density-multiplier', multiplier);
  }, [density]);

  const cycleDensity = () => {
    const modes = ['comfortable', 'compact', 'spacious'];
    const currentIndex = modes.indexOf(density);
    const nextIndex = (currentIndex + 1) % modes.length;
    setDensity(modes[nextIndex]);
  };

  const labels = {
    compact: 'Compact',
    comfortable: 'Comfortable',
    spacious: 'Spacious',
  };

  const iconName = density === 'compact' ? 'densityCompact' : density === 'spacious' ? 'densitySpacious' : 'densityComfortable';

  return (
    <button
      onClick={cycleDensity}
      className="admin-density-toggle"
      aria-label={`Density: ${labels[density]}. Click to change.`}
      title={`Density: ${labels[density]}`}
    >
      <Icon name={iconName} size="sm" />
    </button>
  );
}

